import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullDealsTag from "./fragments/fullDealsTag"
import fullDeal from "./fragments/fullDeal"
import fullDealCategory from "./fragments/fullDealCategory"

/*
  !!! NOTE !!!
  This getHomepage client query is aggregating multiple server queries.
  `homepageLanes` is the only query resolved by the homepage resolver in GraphQL.
  The rest of the queries are bound to the "deals" context.
 */

const query = gql`
  query getHomepage($kind: HomepageKind) {
    homepageDealCategories {
      results {
        ...fullDealCategory
      }
    }
    homepageBanners {
      ...fullDeal
    }
    homepageLanes(kind: $kind) {
      results {
        seeMoreUrl
        linkedEntityUrl
        type
        headerText
        bodyText
        image
        deals {
          ...fullDeal
        }
        tag {
          ...fullDealsTag
        }
      }
    }
  }
  ${fullDealCategory}
  ${fullDealsTag}
  ${fullDeal}
`
export const toString = query.loc.source.body

export const stockJobListKey = getQueryNames(query)[0]

export default query
